/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
import React from 'react';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { observer } from 'mobx-react';

import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';

const RenderFilterList = props => {
  const { data } = props;
  let index = 0;

  const removeFilter = (e, category, value) => {
    if (
      category !== undefined &&
      category !== '' &&
      value !== undefined &&
      value !== ''
    )
      advSearchFilterPopupState.removeAppliedFilterFromGroup(category, value);
  };

  const appliedKeys = Object.keys(data);
  // debugger;
  const appliedFiltersView = [];

  appliedFiltersView.push(
    appliedKeys.map(item => {
      const keyItem = data[item];

      let isExcludeFilter = false;
      if (
        item === 'excludeIndustrySectorsV2' ||
        item === 'excludeCompanyKeywordV2' ||
        item === 'excludeTitle'
      )
        isExcludeFilter = true;
      if (
        item === 'industryName' ||
        item === 'industryKeywordsJson' ||
        item === 'industryKeywords' ||
        item === 'sectorKeywords' ||
        item === 'createdInLastNoOfDays'
      )
        return '';
      if (item === 'industrySectors') {
        if (
          !keyItem.isAllIndustry &&
          keyItem.industries &&
          keyItem.industries.length
        )
          // eslint-disable-next-line curly
          return keyItem.industries.map(value => {
            index += 1;
            // console.log('keyItem keyItem ', value);
            if (typeof value === 'object') {
              if (!value.sectors)
                return (
                  <div
                    key={`filter-item${index}`}
                    className="applied-filter-item"
                    data-category={item}
                    data-name={value.industry}
                    onClick={e => removeFilter(e, item, value.industry)}
                  >
                    <span>{value.industry}</span>
                    {/* <i className="fa fa-times" aria-hidden="true" /> */}
                    <CloseIcon className="svg-close-icon" />
                  </div>
                );
              if (value.sectors && value.sectors.length)
                return value.sectors.map((sectorValue, idx) => {
                  // eslint-disable-next-line no-unused-expressions
                  return (
                    <div
                      key={`filter-item${idx}`}
                      className="applied-filter-item"
                      data-category={item}
                      data-name={sectorValue}
                      onClick={e => removeFilter(e, item, sectorValue)}
                    >
                      <span>{sectorValue}</span>
                      {/* <i className="fa fa-times" aria-hidden="true" /> */}
                      <CloseIcon className="svg-close-icon" />
                    </div>
                  );
                });
            }
            if (value && !value.sectors)
              return (
                <div
                  key={`filter-item${index}`}
                  className="applied-filter-item "
                  data-category={item}
                  data-name={value.id !== undefined ? value.id : ''}
                  onClick={e => removeFilter(e, item, value.id)}
                >
                  <span>{value.name}</span>
                  {/* <i className="fa fa-times" aria-hidden="true" /> */}
                  <CloseIcon className="svg-close-icon" />
                </div>
              );
          });
        return '';
      }

      if (item === 'inclusionListIds' || item === 'exclusionListIds')
        return keyItem.map(value => {
          index += 1;
          const { listName, listId } = value;
          return (
            <div
              key={`filter-item${index}`}
              className="applied-filter-item no-action-allowed"
              data-category={item}
              data-name={listName !== undefined ? listName : ''}
            >
              <span>{listName}</span>
            </div>
          );
        });

      return keyItem.map(value => {
        index += 1;
        // console.log('keyItem keyItem ', value);
        if (typeof value === 'string')
          return (
            <div
              key={`filter-item${index}`}
              className={`applied-filter-item${
                isExcludeFilter ? ' excluded-applied-filter-item' : ''
              }`}
              data-category={item}
              data-name={value}
              onClick={e => removeFilter(e, item, value)}
            >
              <span>{value}</span>
              {/* <i className="fa fa-times" aria-hidden="true" /> */}
              <CloseIcon className="svg-close-icon" />
            </div>
          );

        return (
          <div
            key={`filter-item${index}`}
            className={`applied-filter-item${
              isExcludeFilter ? ' excluded-applied-filter-item' : ''
            }`}
            data-category={item}
            data-name={value.id !== undefined ? value.id : ''}
            onClick={e => removeFilter(e, item, value.id)}
          >
            <span>{value.name}</span>
            {/* <i className="fa fa-times" aria-hidden="true" /> */}
            <CloseIcon className="svg-close-icon" />
          </div>
        );
      });
    }),
  );

  return appliedFiltersView;
};

const AppliedFiltersPopup = observer(() => {
  const [toggleBtn, setToggleBtn] = React.useState(false);
  const [showToggleBtn, setShowToggleBtn] = React.useState(false);

  const calcHeight = () => {
    const ele = document.getElementsByClassName('applied-filter-list');
    console.log('ele ', ele.length);
    if (ele.length)
      if (ele[0].offsetHeight > 70) {
        setShowToggleBtn(true);
      } else {
        setShowToggleBtn(false);
      }

    console.log();
  };

  const toggleFilter = val => {
    if (!val)
      document
        .getElementsByClassName('applied-filter-list-wrapper')[0]
        .scrollTo(0, 0);

    setToggleBtn(val);
  };

  React.useEffect(() => {
    calcHeight();
  });

  const mouseLeaveFn = event => {
    const { currentTarget } = event;
    if (currentTarget && currentTarget.classList.contains('allFilterShown'))
      setToggleBtn(false);
  };

  const clearAllFilter = () => {
    toggleFilter(false);
    advSearchFilterPopupState.clearAllFilters();
  };

  return (
    <div
      className={`applied-filters-popup-section ${toggleBtn ? 'elevated' : ''}`}
    >
      <div
        className={
          toggleBtn === true
            ? 'allFilterShown applied-filters-section'
            : ' applied-filters-section'
        }
        onMouseLeave={e => mouseLeaveFn(e)}
      >
        <div className="parentCont">
          <div
            className={`applied-filter-list-wrapper ${
              toggleBtn === false ? 'max-70' : 'max-all'
            }`}
          >
            <div className="applied-filter-list">
              <RenderFilterList
                data={advSearchFilterPopupState.appliedFilterSectionData}
              />
            </div>
            {toggleBtn === true && (
              <div className="moreContainer inner">
                <div
                  className="view-all-app-filters show-less"
                  onClick={() => toggleFilter(false)}
                >
                  Show Less
                </div>
                <div className="show-more-wrap">
                  <div
                    className="view-all-app-filters clear-filter"
                    onClick={clearAllFilter}
                  >
                    Clear All
                  </div>
                </div>
              </div>
            )}
          </div>
          {toggleBtn === false && (
            <div className="moreContainer">
              {showToggleBtn &&
                (toggleBtn === false ? (
                  <>
                    <div className="show-more-wrap">
                      <div
                        className="view-all-app-filters"
                        onClick={() => toggleFilter(true)}
                      >
                        Show More
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    className="view-all-app-filters show-less"
                    onClick={() => toggleFilter(false)}
                  >
                    Show Less
                  </div>
                ))}
              <div className="show-more-wrap">
                <div
                  className="view-all-app-filters clear-filter"
                  onClick={clearAllFilter}
                >
                  Clear All
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export { AppliedFiltersPopup };
export default AppliedFiltersPopup;
